import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'; // Importing the HelpOutlineIcon


const colors = {
    icon: '#58585A',
    tooltipBg: '#EDF1F8',
    tooltipBorder: '#58585A',
    tooltipText: '#58585A',
};

const fontSize = {
    label: '0.9rem',
    tooltip: '0.8rem',
};

const LabelContainer = styled.div`
    flex: 1;
    display: grid;
    grid-template-columns: 1fr 4fr 1fr; // Adjusted to maintain the original flex proportions
    align-items: center;
    position: relative;
    grid-gap: 0.5rem; // Adds space between grid items, adjust as needed
`;

// Utilizing the space without an extra component might be more efficient unless EmptySpace has specific styles not shown here.

const Label = styled.label`
    font-size: ${fontSize.label};
    text-align: center;
    // Removed the flex property as it's no longer needed with grid
`;

const StyledHelpOutlineIcon = styled(HelpOutlineIcon)`
    color: ${colors.icon};
    padding-left: 0.5rem; // Consider if this padding is still necessary with the grid gap
    padding-bottom: 1rem;
    cursor: pointer;
    justify-self: center; // This centers the icon in its grid cell
    box-sizing: content-box !important; 
`;


const Tooltip = styled.span<TooltipProps>`
    display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${colors.tooltipBg};
    padding: 0.5rem;
    border-radius: 0.3rem;
    border: 1px solid ${colors.tooltipBorder};
    font-size: ${fontSize.tooltip};
    color: ${colors.tooltipText};
    z-index: 15;
    min-width: 15vw;
    white-space: pre-wrap;
    // Extend styles here if needed
`;

interface TooltipProps {
    isVisible: boolean;
}

interface Props {
    label: string;
    tooltip: React.ReactNode;
}

const TooltipLabel: React.FC<Props> = ({ label, tooltip }) => {
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);

    const toggleTooltip = (event: React.MouseEvent) => {
        event.stopPropagation();
        setIsTooltipVisible(!isTooltipVisible);
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (isTooltipVisible && !(event.target as HTMLElement).closest("span")) {
                setIsTooltipVisible(false);
            }
        };

        if (isTooltipVisible) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isTooltipVisible]);

    return (
        <>
            <LabelContainer>
                <div /> {/* EmptySpace */}
                <Label>{label}</Label>
                <StyledHelpOutlineIcon fontSize='medium' onClick={toggleTooltip} />
                <Tooltip isVisible={isTooltipVisible}>{tooltip}</Tooltip>
            </LabelContainer>
        </>
    );
};

export default TooltipLabel;
